"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnglePerLengthJson = exports.AnglePerLength = exports.AnglePerLengthTexts = exports.AnglePerLengthUnits = void 0;
const Quantity_1 = require("./Quantity");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
var AnglePerLengthUnits;
(function (AnglePerLengthUnits) {
    AnglePerLengthUnits["default"] = "deg_m";
    AnglePerLengthUnits["deg_m"] = "deg_m";
})(AnglePerLengthUnits = exports.AnglePerLengthUnits || (exports.AnglePerLengthUnits = {}));
exports.AnglePerLengthTexts = {
    [AnglePerLengthUnits.default]: '°/m',
    [AnglePerLengthUnits.deg_m]: '°/m',
};
class AnglePerLength extends Quantity_1.Quantity {
    constructor() {
        super(...arguments);
        this.className = 'AnglePerLength';
        this.defaultUnit = 'deg_m';
        this.unitTexts = exports.AnglePerLengthTexts;
    }
    static getUnitText(unit) {
        return exports.AnglePerLengthTexts[unit];
    }
    static fromJson(q) {
        if (!(0, echain_shared_ts_utils_1.isValueInEnum)(AnglePerLengthUnits, q.Unit)) {
            throw new Error(`AnglePerLength.fromJson: Unit not supported: ${q.Unit}`);
        }
        return new AnglePerLength(q);
    }
    static deg_m(v) {
        return new AnglePerLength(v, AnglePerLengthUnits.deg_m);
    }
    set deg_m(v) {
        this.setValueUnit(v, AnglePerLengthUnits.deg_m);
    }
    get deg_m() {
        switch (this.unit) {
            case AnglePerLengthUnits.deg_m:
                return this.value;
        }
        throw new Error(`AnglePerLength.deg_m: unknown unit ${this.unit}`);
    }
    clone() {
        return AnglePerLength.fromJson(this.toJson());
    }
    getValue(unit) {
        switch (unit) {
            case 'default':
            case AnglePerLengthUnits.deg_m:
                return this.deg_m;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(unit);
        }
    }
}
exports.AnglePerLength = AnglePerLength;
AnglePerLength.units = Array.from(new Set(Object.values(AnglePerLengthUnits).map((u) => u)));
const isAnglePerLengthJson = (l) => {
    return (0, Quantity_1.isQuantityJson)(l) && (0, echain_shared_ts_utils_1.isValueInEnum)(AnglePerLengthUnits, l.Unit);
};
exports.isAnglePerLengthJson = isAnglePerLengthJson;
//# sourceMappingURL=AnglePerLength.js.map